
import { ProjectSetting } from "../../classes"

const ProjectSettingModule = {
  namespaced: true,

  state: () => ({}),
  actions: {
    updateProjectSetting: async ({ commit, state }, payload) => {
      try {
        let projectSetting = await ProjectSetting.updateProjectSetting(payload)
        return projectSetting
      } catch (error) {
        throw error
      }
    },
  },
  getters: {},
  mutations: {},
};
export default ProjectSettingModule;
